import { addCoreSelectionsSyncSlice } from './add';
import { combineReducers } from 'redux';
import { defaultSelectionState } from './state';
import { joinSyncReducers } from '@sonar-software/xuder';
import { removeCoreSelectionsSyncSlice } from './remove';

export const coreSelectionsReducers = combineReducers({
	read: joinSyncReducers([
		addCoreSelectionsSyncSlice.syncReducer,
		removeCoreSelectionsSyncSlice.syncReducer
	], defaultSelectionState)
});
